<greco-calendar-details [community]="community" [calendar]="calendar"></greco-calendar-details>
<greco-calendar-template-details
  [community]="community"
  [calendar]="calendar"
  (changed)="calendar = $event"
></greco-calendar-template-details>
